import React, { useState } from "react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { api } from "../../lib/api";
import { stateName } from "../../data/intake";
import { toast } from "sonner";

const REASONS = {
  claim_filed_outside_service_area: "Claim filed outside our service states",
  claim_state_unsure: "Applicant is not sure where the claim is filed",
  claim_state_missing: "Claim-filed state not provided",
};
const STATUS_STYLES = {
  pending: "bg-[#FFFBEB] border-[#FDE68A] text-[#92400E]",
  ineligible: "bg-[#FEF2F2] border-[#FECACA] text-[#991B1B]",
  cleared: "bg-[#ECFDF5] border-[#A7F3D0] text-[#065F46]",
};

export default function ServiceAreaReviewBanner({ application, onResolved }) {
  const review = application?.service_area_review;
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (!review) return null;

  const decide = async (decision) => {
    setBusy(true);
    try {
      await api.post(`/applications/${application.id}/service-area-review`, { decision, note });
      toast.success(decision === "eligible" ? "Eligibility confirmed" : "Marked ineligible");
      onResolved?.();
    } catch { toast.error("Failed to save decision"); }
    setBusy(false);
  };

  const claim = review.claim_state ? (review.claim_state === "UNSURE" ? "Not sure" : stateName(review.claim_state)) : "Not provided";
  return (
    <div className={`rounded-2xl border p-5 text-sm ${STATUS_STYLES[review.status]}`} data-testid="service-area-review-banner">
      <div className="font-semibold" data-testid="service-area-review-status">
        Manual service-area review: {review.status === "pending" ? "Pending" : review.status === "cleared" ? "Eligible (cleared)" : "Ineligible"}
      </div>
      <div className="mt-1">{REASONS[review.reason] || review.reason} · Residence: {stateName(review.residence_state)} · Claim filed in: {claim}</div>
      {review.status === "pending" ? (
        <>
          <div className="mt-1">Approval and funding are blocked until eligibility is confirmed.</div>
          <Textarea className="mt-3 bg-white" rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Review note (optional)" data-testid="service-area-review-note" />
          <div className="mt-3 flex gap-2">
            <Button size="sm" disabled={busy} onClick={() => decide("eligible")} className="btn-primary-navy" data-testid="service-area-review-eligible-btn">Confirm eligible</Button>
            <Button size="sm" variant="outline" disabled={busy} onClick={() => decide("ineligible")} data-testid="service-area-review-ineligible-btn">Mark ineligible</Button>
          </div>
        </>
      ) : (
        <div className="mt-1 text-xs">Resolved by {review.resolved_by} on {new Date(review.resolved_at).toLocaleString()}{review.note ? ` · ${review.note}` : ""}</div>
      )}
    </div>
  );
}
